var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.46094C8 1.91646 7.55312 1.47656 7 1.47656C6.44688 1.47656 6 1.91646 6 2.46094V6.89062H1.5C0.946875 6.89062 0.5 7.33052 0.5 7.875C0.5 8.41948 0.946875 8.85938 1.5 8.85938H6V13.2891C6 13.8335 6.44688 14.2734 7 14.2734C7.55312 14.2734 8 13.8335 8 13.2891V8.85938H12.5C13.0531 8.85938 13.5 8.41948 13.5 7.875C13.5 7.33052 13.0531 6.89062 12.5 6.89062H8V2.46094Z",
    fill: "#43BBC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b51055c67b4fda9ad017bf9d5e1ecc6a.svg";
export { ForwardRef as ReactComponent };